<template>
  <div class="min-h-screen bg-white">
    <slot />
  </div>
  <Footer hide-ticket />
</template>
